import classNames from 'clsx';
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import CoinIcon from '@swf/core/assets/icons/stars-coin.png';
import { select } from '@swf/core/store';

import styles from './StarsCoinBalance.scss';

const StarsCoinBalance: React.FC<{ className?: string }> = ({ className }) => {
  const { formatNumber } = useIntl();
  const balance = useSelector(select.account.getStarsCoinBalance);
  return (
    <div className={classNames(styles.balance, className)}>
      <img className={styles.svg} src={CoinIcon} alt="" />
      <span>{formatNumber(balance)}</span>
    </div>
  );
};

export default StarsCoinBalance;
